import { render } from "./TestView.vue?vue&type=template&id=20049a41"
import script from "./TestView.vue?vue&type=script&setup=true&lang=js"
export * from "./TestView.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/TestView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20049a41"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20049a41', __exports__)) {
    api.reload('20049a41', __exports__)
  }
  
  module.hot.accept("./TestView.vue?vue&type=template&id=20049a41", () => {
    api.rerender('20049a41', render)
  })

}


export default __exports__